import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setupAutoSplitModalHeader: {
    description: 'Setup Auto-Split modal header',
    defaultMessage: 'Set Up Auto-Split',
    id: 'zmxjyR',
  },
  autoSplitModalIntroduction: {
    defaultMessage: 'You can setup Auto-Split on the Products Page in 3 different ways:',
    id: 'eHqTnL',
    description:
      'introductory text displayed in the modal before the numbered list of instructions for setting up Auto-Split for a product',
  },
  autoSplitModalInstruction1: {
    defaultMessage:
      'Configure products individually by clicking on a product to open the Product Details. In the Shipping tab, you will be able to choose the Auto-Split option for that product.',
    id: '2y/aqF',
    description: 'first numbered item in the list on instructions for setting up Auto-Split for a product',
  },
  autoSplitModalInstruction2: {
    defaultMessage:
      'Configure products in bulk by selecting all the products you want to apply the Auto-Split setting to, click the Auto-Split button, and select an Auto-Split option to apply to the selected products.',
    id: 'gbxlM0',
    description: 'second numbered item in the list on instructions for setting up Auto-Split for a product',
  },
  autoSplitModalInstruction3: {
    defaultMessage: 'Configure products in bulk by uploading a CSV with the Auto-Split column populated.',
    id: 'VrR3eN',
    description: 'third numbered item in the list on instructions for setting up Auto-Split for a product',
  },
  goToProductsLink: {
    defaultMessage: 'Go to Products',
    id: 'uqsMeu',
    description: 'Link on the Set Up Auto-Split modal that redirects the user to the Products page',
  },
});
